import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Transition as _Transition, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icons/abc.png'
import _imports_1 from '@/assets/images/icons/light.png'
import _imports_2 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "p-6 bg-white shadow-sm rounded-2xl mb-10"
}
const _hoisted_3 = { class: "flex items-center justify-between mb-6" }
const _hoisted_4 = { class: "font-semibold text-neutral-600" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  key: 0,
  class: "font-semibold text-neutral-600 mr-8"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z",
    fill: "#94A3B8"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_25844_32059)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.00048 2.63289V1.98933C3.00048 1.89595 2.98209 1.80348 2.94635 1.7172C2.91061 1.63092 2.85823 1.55253 2.7922 1.4865C2.72617 1.42046 2.64777 1.36808 2.5615 1.33235C2.47522 1.29661 2.38275 1.27822 2.28936 1.27822H1.42178C1.42179 0.939216 1.55646 0.614096 1.79618 0.374383C2.03589 0.134671 2.36101 1.41443e-06 2.70002 0H14.3658C14.5337 0 14.6999 0.0330627 14.8549 0.0972996C15.01 0.161537 15.1509 0.25569 15.2696 0.374384C15.3883 0.493078 15.4825 0.633988 15.5467 0.789069C15.6109 0.94415 15.644 1.11036 15.644 1.27822V14.7218C15.644 14.8896 15.6109 15.0559 15.5467 15.2109C15.4825 15.366 15.3883 15.5069 15.2696 15.6256C15.1509 15.7443 15.01 15.8385 14.8549 15.9027C14.6999 15.9669 14.5337 16 14.3658 16H2.70002C2.36101 16 2.03589 15.8653 1.79618 15.6256C1.55646 15.3859 1.42179 15.0608 1.42178 14.7218H2.28936C2.38275 14.7218 2.47522 14.7034 2.56149 14.6677C2.64777 14.6319 2.72616 14.5795 2.7922 14.5135C2.85823 14.4475 2.91061 14.3691 2.94635 14.2828C2.98208 14.1965 3.00047 14.1041 3.00047 14.0107V13.3671C3.00047 13.2737 2.98208 13.1813 2.94635 13.095C2.91061 13.0087 2.85823 12.9303 2.7922 12.8643C2.72616 12.7982 2.64777 12.7459 2.56149 12.7101C2.47522 12.6744 2.38275 12.656 2.28936 12.656H1.42178V11.8773H2.28936C2.38275 11.8773 2.47522 11.8589 2.56149 11.8232C2.64777 11.7875 2.72616 11.7351 2.7922 11.6691C2.85823 11.603 2.91061 11.5246 2.94635 11.4384C2.98208 11.3521 3.00047 11.2596 3.00047 11.1662V10.5227C3.00047 10.4293 2.98208 10.3368 2.94635 10.2505C2.91061 10.1643 2.85823 10.0859 2.7922 10.0198C2.72616 9.9538 2.64777 9.90142 2.56149 9.86568C2.47522 9.82995 2.38275 9.81155 2.28936 9.81156H1.42178V9.03289H2.28936C2.38275 9.03289 2.47522 9.0145 2.56149 8.97876C2.64777 8.94303 2.72616 8.89065 2.7922 8.82461C2.85823 8.75858 2.91061 8.68019 2.94635 8.59391C2.98208 8.50764 3.00047 8.41516 3.00047 8.32178V7.67822C3.00047 7.58484 2.98208 7.49237 2.94635 7.40609C2.91061 7.31981 2.85823 7.24142 2.7922 7.17539C2.72616 7.10935 2.64777 7.05697 2.56149 7.02124C2.47522 6.9855 2.38275 6.96711 2.28936 6.96711H1.42178V6.18845H2.28936C2.38275 6.18845 2.47522 6.17005 2.56149 6.13432C2.64777 6.09858 2.72616 6.0462 2.7922 5.98017C2.85823 5.91414 2.91061 5.83574 2.94635 5.74947C2.98208 5.66319 3.00047 5.57072 3.00047 5.47733V4.83378C3.00047 4.74039 2.98208 4.64792 2.94635 4.56165C2.91061 4.47537 2.85823 4.39698 2.7922 4.33094C2.72616 4.26491 2.64777 4.21253 2.56149 4.17679C2.47522 4.14106 2.38275 4.12267 2.28936 4.12267H1.42178V3.344H2.28937C2.38275 3.344 2.47522 3.32561 2.5615 3.28987C2.64777 3.25414 2.72617 3.20176 2.7922 3.13572C2.85823 3.06969 2.91061 2.9913 2.94635 2.90502C2.98209 2.81875 3.00048 2.72627 3.00048 2.63289ZM10.9998 3.91667C10.6776 3.91667 10.4164 4.17783 10.4164 4.5V11.5H9.83309V7.41667C9.83309 7.0945 9.57192 6.83333 9.24976 6.83333H8.08309C7.76092 6.83333 7.49976 7.0945 7.49976 7.41667V11.5H6.91642V9.75C6.91642 9.42783 6.65526 9.16667 6.33309 9.16667H5.16642C4.84426 9.16667 4.58309 9.42783 4.58309 9.75V11.5H4.29142C4.13034 11.5 3.99976 11.6306 3.99976 11.7917C3.99976 11.9528 4.13034 12.0833 4.29142 12.0833H13.0414C13.2025 12.0833 13.3331 11.9528 13.3331 11.7917C13.3331 11.6306 13.2025 11.5 13.0414 11.5H12.7498V4.5C12.7498 4.17783 12.4886 3.91667 12.1664 3.91667H10.9998Z",
      fill: "#94A3B8"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.29017 1.81185H0.533247C0.435063 1.81185 0.355469 1.89144 0.355469 1.98963V2.63265C0.355469 2.73083 0.435063 2.81043 0.533247 2.81043H2.29017C2.38835 2.81043 2.46795 2.73083 2.46795 2.63265V1.98963C2.46795 1.89144 2.38835 1.81185 2.29017 1.81185Z",
      fill: "#94A3B8"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0.533247 7.50074H2.29017C2.38835 7.50074 2.46795 7.58033 2.46795 7.67852V8.32154C2.46795 8.41972 2.38835 8.49932 2.29017 8.49932H0.533247C0.435063 8.49932 0.355469 8.41972 0.355469 8.32154V7.67852C0.355469 7.58033 0.435063 7.50074 0.533247 7.50074Z",
      fill: "#94A3B8"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.29017 4.65629H0.533247C0.435063 4.65629 0.355469 4.73589 0.355469 4.83407V5.47709C0.355469 5.57528 0.435063 5.65487 0.533247 5.65487H2.29017C2.38835 5.65487 2.46795 5.57528 2.46795 5.47709V4.83407C2.46795 4.73589 2.38835 4.65629 2.29017 4.65629Z",
      fill: "#94A3B8"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.29017 10.3452H0.533247C0.435063 10.3452 0.355469 10.4248 0.355469 10.523V11.166C0.355469 11.2642 0.435063 11.3438 0.533247 11.3438H2.29017C2.38835 11.3438 2.46795 11.2642 2.46795 11.166V10.523C2.46795 10.4248 2.38835 10.3452 2.29017 10.3452Z",
      fill: "#94A3B8"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.29017 13.1896H0.533247C0.435063 13.1896 0.355469 13.2692 0.355469 13.3674V14.0104C0.355469 14.1086 0.435063 14.1882 0.533247 14.1882H2.29017C2.38835 14.1882 2.46795 14.1086 2.46795 14.0104V13.3674C2.46795 13.2692 2.38835 13.1896 2.29017 13.1896Z",
      fill: "#94A3B8"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_25844_32059" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mt-0.5" }, "Áp dụng ngay", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.4705 6.65175L13.7105 5.41172C13.8463 5.27586 13.9143 5.20793 13.9669 5.14597C14.6011 4.39929 14.6011 3.30311 13.9669 2.55644C13.9143 2.49448 13.8463 2.42655 13.7105 2.29069C13.5746 2.15482 13.5067 2.08689 13.4447 2.03426C12.6981 1.40004 11.6019 1.40004 10.8552 2.03426C10.7933 2.08688 10.7253 2.15479 10.5895 2.29059L10.5895 2.29067L10.5894 2.29069L9.33123 3.5489C10.0749 4.84309 11.1586 5.91837 12.4705 6.65175ZM7.87657 5.00356L2.86297 10.0172C2.43791 10.4422 2.22538 10.6547 2.08565 10.9158C1.94591 11.1769 1.88697 11.4717 1.76908 12.0611L1.37342 14.0394C1.3069 14.372 1.27364 14.5383 1.36825 14.6329C1.46286 14.7275 1.62916 14.6943 1.96177 14.6277L3.94005 14.2321L3.94007 14.2321L3.94009 14.2321C4.52951 14.1142 4.82423 14.0553 5.08532 13.9155C5.34641 13.7758 5.55894 13.5633 5.98398 13.1382L5.984 13.1382L5.98401 13.1382L11.012 8.11019C9.75135 7.31198 8.68226 6.25011 7.87657 5.00356Z",
    fill: "#94A3B8"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mt-0.5" }, "Chỉnh sửa", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6" }
const _hoisted_16 = { class: "p-6 border lg:rounded-l-lg md:rounded-tl-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none" }
const _hoisted_17 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực ")
], -1)
const _hoisted_20 = { class: "p-6 border border-neutral-200 w-full md:border-l-0 md-down:border-t-0" }
const _hoisted_21 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu")
], -1)
const _hoisted_24 = { class: "p-6 border border-neutral-200 w-full md:rounded-tr-lg lg:rounded-tr-none md:border-l-0 md-down:border-t-0" }
const _hoisted_25 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu lặp lại")
], -1)
const _hoisted_28 = { class: "p-6 border border-neutral-200 w-full lg:border-l-0 lg-down:border-t-0 md:rounded-bl-lg lg:rounded-bl-none" }
const _hoisted_29 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu mới")
], -1)
const _hoisted_32 = { class: "p-6 border border-neutral-200 w-full md:border-l-0 lg-down:border-t-0" }
const _hoisted_33 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Từ MT tạm dừng")
], -1)
const _hoisted_36 = { class: "p-6 border md:border-l-0 lg:rounded-r-lg md:rounded-br-lg border-neutral-200 w-full lg-down:border-t-0 md-down:rounded-b md-down:rounded-t-none" }
const _hoisted_37 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Từ Ngân hàng MT")
], -1)
const _hoisted_40 = { class: "mt-4 flex justify-end items-center text-gray-700" }
const _hoisted_41 = {
  key: 0,
  class: "flex gap-2"
}
const _hoisted_42 = { class: "flex items-center" }
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_45 = { class: "ml-4 text-blue-600 font-semibold" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = {
  key: 2,
  class: "text-center text-neutral-500 p-6 text-lg"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = {
  key: 3,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  height: "250",
  width: "250"
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}, " Lớp nhóm chưa có Kế hoạch dự kiến nào. Kế hoạch dự kiến sẽ được tạo tự động sau khi hoàn thành Báo cáo kế hoạch ", -1)
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmSendReportTarget = _resolveComponent("ConfirmSendReportTarget")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GoalList = _resolveComponent("GoalList")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.modalType === _ctx.type.CREATE)
          ? (_openBlock(), _createBlock(_component_ConfirmSendReportTarget, {
              key: 0,
              onClose: _ctx.cancel,
              onSubmit: _ctx.sendNotification,
              name: _ctx.reportName
            }, null, 8, ["onClose", "onSubmit", "name"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.report?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, " Kế hoạch " + _toDisplayString(_ctx.report?.order), 1),
                    _createElementVNode("div", _hoisted_5, [
                      (_ctx.report?.applied_at)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Áp dụng: " + _toDisplayString(_ctx.$filters.formatDate(_ctx.report?.applied_at)), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Menu, {
                        as: "div",
                        class: "ml-3 relative"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_MenuButton, { class: "rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" }, {
                              default: _withCtx(() => [
                                _hoisted_7,
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-200",
                            "enter-from-class": "transform opacity-0 scale-95",
                            "enter-to-class": "transform opacity-100 scale-100",
                            "leave-active-class": "transition ease-in duration-75",
                            "leave-from-class": "transform opacity-100 scale-100",
                            "leave-to-class": "transform opacity-0 scale-95"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MenuItems, { class: "origin-top-right absolute right-0 mt-2 w-60 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100" }, {
                                default: _withCtx(() => [
                                  (_ctx.report && !_ctx.report.sent_at)
                                    ? (_openBlock(), _createBlock(_component_MenuItem, {
                                        key: 0,
                                        onClick: _ctx.confirmSendOpen
                                      }, {
                                        default: _withCtx(({ active }) => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer", active ? '' : ''])
                                          }, _hoisted_11, 2)
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (
											_ctx.report?.id &&
											_ctx.report?.state !== 'draft' &&
											_ctx.report?.state !== 'completed'
										)
                                    ? (_openBlock(), _createBlock(_component_MenuItem, {
                                        key: 1,
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (
											_ctx.$router.push(
												`/group-class-plans/${_ctx.id}/create-future?plan_id=${_ctx.report?.id}`
											)
										))
                                      }, {
                                        default: _withCtx(({ active }) => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer", active ? '' : ''])
                                          }, _hoisted_14, 2)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.skills_count || '0'), 1)
                    ]),
                    _hoisted_19
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.goals_count || '0'), 1)
                    ]),
                    _hoisted_23
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.continued_goals_count || '0'), 1)
                    ]),
                    _hoisted_27
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.new_goals_count || '0'), 1)
                    ]),
                    _hoisted_31
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.goals_from_stopped_count || '0'), 1)
                    ]),
                    _hoisted_35
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createTextVNode(" " + _toDisplayString(_ctx.stats?.goals_from_lib_count || '0'), 1)
                    ]),
                    _hoisted_39
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  (_ctx.report && _ctx.report.sent_at && _ctx.report.sent_by_staff)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createVNode(_component_router_link, {
                          to: `/record/employee/${_ctx.report.sent_by_staff?.id}`
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", null, [
                                (
										_ctx.report.sent_by_staff?.profile_photo
											?.w200
									)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                      src: 
										_ctx.report.sent_by_staff?.profile_photo
											?.w200
									,
                                      alt: ""
                                    }, null, 8, _hoisted_43))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                      style: _normalizeStyle({
										background:
											_ctx.report.sent_by_staff?.profile_photo
												?.default?.color,
									})
                                    }, [
                                      _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.report.sent_by_staff?.profile_photo
												?.default?.initial), 1)
                                    ], 4))
                              ]),
                              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.report.sent_by_staff.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _createTextVNode(" đã gửi KH tới PH "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatDateTime(_ctx.report.sent_at)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_46))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.skills?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (group, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: group.id
                  }, [
                    _createVNode(_component_GoalList, {
                      data: group,
                      "is-group": true,
                      index: Number(index),
                      "student-id": Number(_ctx.id),
                      "key-goals": "group_goals",
                      class: "mb-6"
                    }, null, 8, ["data", "index", "student-id"])
                  ]))
                }), 128))
              ]))
            : (_ctx.report?.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createTextVNode(" Kế hoạch dự kiến chưa có mục tiêu. "),
                  _hoisted_49,
                  _createTextVNode(" Bạn hãy chọn Chỉnh sửa kế hoạch để thêm mục tiêu cho lớp nhóm. ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_53))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createVNode(_component_Loading)
        ]))
  ], 64))
}